import { useEffect, useState } from "react";

export default function ProspDailySettings({ users, stores }) {
  const [rows,setRows]=useState([]);
  const [error,setError]=useState("");
  const [loading,setLoading]=useState(true);
  const [saving,setSaving]=useState(null);
  const [saved,setSaved]=useState(null);
  useEffect(()=>{
    let active=true;
    fetch("/api/prospeccao/config",{credentials:"same-origin",cache:"no-store"})
      .then(async r=>{const j=await r.json();if(!r.ok)throw new Error(j.error || "Não foi possível ler as cotas.");return j;})
      .then(j=>{if(active)setRows(j.consultores || []);})
      .catch(e=>{if(active)setError(e.message);})
      .finally(()=>{if(active)setLoading(false);});
    return ()=>{active=false;};
  },[]);
  async function save(row) {
    const quantity=Number(row.itensPorDia);
    if (!Number.isInteger(quantity) || quantity<1 || quantity>100) {
      setError("Informe uma quantidade inteira de 1 a 100.");return;
    }
    setSaving(row.consultantId);setSaved(null);setError("");
    try {
      const r=await fetch("/api/prospeccao/config",{method:"POST",credentials:"same-origin",
        headers:{"Content-Type":"application/json"},body:JSON.stringify({consultantId:row.consultantId,itensPorDia:quantity})});
      const j=await r.json();
      if(!r.ok || !j.ok)throw new Error(j.error || "A configuração não foi salva.");
      setSaved(row.consultantId);
    } catch(e) {setError(e.message);}
    finally {setSaving(null);}
  }
  return <section aria-label="Quantidade diária de contatos novos" style={{background:"#fff",padding:20,border:"1px solid #E2E8F0",borderRadius:12,marginBottom:20}}>
    <h3 style={{marginTop:0}}>Contatos novos por dia — Prospecção</h3>
    <p style={{fontSize:12,color:"#64748B"}}>Retornos não ocupam esta cota. Concluir um contato não cria outra vaga no mesmo dia. Aumentar a cota permite completar a fila no próximo acesso; diminuir não retira contatos já distribuídos. A meta comercial de 25/dia do painel é independente.</p>
    {loading && <p role="status">Carregando configurações…</p>}
    {error && <p role="alert" style={{color:"#B42318"}}>{error}</p>}
    {rows.map(row=>{
      const name=users.find(u=>Number(u.id)===row.consultantId)?.name || `Consultor ${row.consultantId}`;
      return <div key={row.consultantId} style={{display:"flex",alignItems:"center",gap:12,flexWrap:"wrap",marginBottom:10}}>
        <span style={{minWidth:210,fontSize:12}}>{name} · {stores.find(s=>Number(s.id)===row.storeId)?.name || `Loja ${row.storeId}`}</span>
        <input type="number" min="1" max="100" step="1" aria-label={`Contatos novos por dia para ${name}`} value={row.itensPorDia}
          onChange={e=>{setSaved(null);setRows(prev=>prev.map(r=>r.consultantId===row.consultantId ? {...r,itensPorDia:e.target.value} : r));}}
          disabled={saving!=null} style={{width:80,padding:7,border:"1px solid #CBD5E1",borderRadius:6}} />
        <button type="button" disabled={saving!=null} onClick={()=>save(row)} aria-label={`Salvar cota de ${name}`}
          style={{padding:"7px 12px",borderRadius:6,border:"1px solid #CBD5E1",cursor:"pointer"}}>
          {saving===row.consultantId ? "Salvando…" : "Salvar"}</button>
        {saved===row.consultantId && <span role="status">Configuração salva</span>}
      </div>;
    })}
  </section>;
}
